export enum Icon {
  Close = 'close',
  Add = 'add',
  Edit = 'edit',
  Copy = 'copy',
  Delete = 'delete',
  Import = 'import',
  Up = 'up',
  Down = 'down',
  ArrowUp = 'arrow-up',
  ArrowDown = 'arrow-down',
  Move = 'move',
  Intake = 'intake',
  Lock = 'lock',
  LockLarge = 'lock-large',
  Unlock = 'unlock',
  Link = 'link',
  ExternalLink = 'external-link',
  Info = 'info',
}

export enum IconClass {
  Default = 'button-svg',
  FillBlack = 'button-svg-fill-black',
  FillBlack2 = 'button-svg-fill-black-2',
  FillBlackSolid = 'button-svg-fill-black-solid',
  FillWhite = 'button-svg-fill-white',
  FillTertiaryTeal = 'button-svg-fill-tertiary-teal',
  StrokeBlack = 'button-svg-stroke-black',
  StrokeBlackSolid = 'button-svg-stroke-black-solid',
  StrokeWhite = 'button-svg-stroke-white',
}

interface Props {
  icon: Icon
  className?: IconClass
  color?: string
  width?: string | number
  height?: string | number
}

export const primaryColor = '#8a68c8'

function Svg({ icon, className, color, width, height }: Props) {
  className = className || IconClass.Default

  switch (icon) {
    case Icon.Close:
      return (
        <svg
          width={width || height || '24'}
          height={height || width || '24'}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4119 12.0002L17.7119 7.71019C18.104 7.31806 18.104 6.68231 17.7119 6.29019C17.3198 5.89806 16.684 5.89806 16.2919 6.29019L12.0019 10.5902L7.71189 6.29019L7.71189 6.29019C7.31977 5.89806 6.68401 5.89806 6.29189 6.29019C5.89977 6.68231 5.89977 7.31807 6.29189 7.71019L10.5919 12.0002L6.29189 16.2902C5.89977 16.6791 5.89717 17.3123 6.28609 17.7044C6.28802 17.7063 6.28995 17.7083 6.29189 17.7102H6.29189C6.68081 18.1023 7.31397 18.1049 7.70609 17.716C7.70803 17.7141 7.70997 17.7121 7.71189 17.7102L12.0019 13.4102L16.2919 17.7102V17.7102C16.6808 18.1023 17.314 18.1049 17.7061 17.716C17.708 17.7141 17.71 17.7121 17.7119 17.7102C18.104 17.3213 18.1066 16.6881 17.7177 16.296C17.7158 16.294 17.7138 16.2921 17.7119 16.2902L13.4119 12.0002Z"
            // fill="#51597B"
          />
        </svg>
      )
    case Icon.Add:
      return (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.583 8.25H10.083V3.75C10.083 3.33579 9.74722 3 9.33301 3C8.91879 3 8.58301 3.33579 8.58301 3.75V8.25H4.08301C3.66879 8.25 3.33301 8.58579 3.33301 9C3.33301 9.41421 3.66879 9.75 4.08301 9.75H8.58301V14.25C8.58301 14.6642 8.91879 15 9.33301 15C9.74722 15 10.083 14.6642 10.083 14.25V9.75H14.583C14.9972 9.75 15.333 9.41421 15.333 9C15.333 8.58579 14.9972 8.25 14.583 8.25Z"
          />
        </svg>
      )
    case Icon.Edit:
      return (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4941 4.89324L11.6674 3.06657C11.1739 2.60301 10.4113 2.58294 9.89408 3.01991L3.89408 9.01991C3.67859 9.23722 3.54442 9.52204 3.51408 9.82657L3.22741 12.6066L3.22741 12.6066C3.20923 12.8043 3.28011 12.9998 3.42075 13.1399H3.42075C3.54656 13.2647 3.71688 13.3343 3.89408 13.3332H3.95408L6.73408 13.0799C7.03861 13.0496 7.32344 12.9154 7.54075 12.6999L13.5407 6.69991C14.0256 6.18768 14.0047 5.37975 13.4941 4.89324V4.89324ZM6.61523 11.7465L4.61523 11.9332L4.79523 9.93322L8.5619 6.21322L10.3619 8.01322L6.61523 11.7465ZM11.2274 7.11991L9.44075 5.33324L10.7407 3.99991L12.5607 5.81991L11.2274 7.11991Z"
          />
        </svg>
      )
    case Icon.Copy:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          className={className}
        >
          <path
            d="M15.8335 6.16675H7.50016C6.57969 6.16675 5.8335 6.91294 5.8335 7.83341V16.1667C5.8335 17.0872 6.57969 17.8334 7.50016 17.8334H15.8335C16.754 17.8334 17.5002 17.0872 17.5002 16.1667V7.83341C17.5002 6.91294 16.754 6.16675 15.8335 6.16675Z"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.50016 12.8334C1.5835 12.8334 0.833496 12.0834 0.833496 11.1667V2.83341C0.833496 1.91675 1.5835 1.16675 2.50016 1.16675H10.8335C11.7502 1.16675 12.5002 1.91675 12.5002 2.83341"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case Icon.Delete:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path d="M8.33366 4.16667H11.667C11.667 3.72464 11.4914 3.30072 11.1788 2.98816C10.8663 2.67559 10.4424 2.5 10.0003 2.5C9.5583 2.5 9.13438 2.67559 8.82181 2.98816C8.50925 3.30072 8.33366 3.72464 8.33366 4.16667ZM7.08366 4.16667C7.08366 3.78364 7.1591 3.40437 7.30568 3.05051C7.45225 2.69664 7.66709 2.37511 7.93793 2.10427C8.20877 1.83343 8.5303 1.61859 8.88417 1.47202C9.23803 1.32544 9.6173 1.25 10.0003 1.25C10.3833 1.25 10.7626 1.32544 11.1165 1.47202C11.4704 1.61859 11.7919 1.83343 12.0627 2.10427C12.3336 2.37511 12.5484 2.69664 12.695 3.05051C12.8416 3.40437 12.917 3.78364 12.917 4.16667H17.7087C17.8744 4.16667 18.0334 4.23251 18.1506 4.34973C18.2678 4.46694 18.3337 4.62591 18.3337 4.79167C18.3337 4.95743 18.2678 5.1164 18.1506 5.23361C18.0334 5.35082 17.8744 5.41667 17.7087 5.41667H16.6087L15.6337 15.5092C15.5589 16.2825 15.1987 17.0002 14.6234 17.5224C14.0481 18.0445 13.2989 18.3336 12.522 18.3333H7.47866C6.70188 18.3334 5.95291 18.0442 5.37778 17.5221C4.80266 16.9999 4.4426 16.2823 4.36783 15.5092L3.39199 5.41667H2.29199C2.12623 5.41667 1.96726 5.35082 1.85005 5.23361C1.73284 5.1164 1.66699 4.95743 1.66699 4.79167C1.66699 4.62591 1.73284 4.46694 1.85005 4.34973C1.96726 4.23251 2.12623 4.16667 2.29199 4.16667H7.08366ZM8.75033 8.125C8.75033 7.95924 8.68448 7.80027 8.56727 7.68306C8.45006 7.56585 8.29109 7.5 8.12533 7.5C7.95957 7.5 7.80059 7.56585 7.68338 7.68306C7.56617 7.80027 7.50033 7.95924 7.50033 8.125V14.375C7.50033 14.5408 7.56617 14.6997 7.68338 14.8169C7.80059 14.9342 7.95957 15 8.12533 15C8.29109 15 8.45006 14.9342 8.56727 14.8169C8.68448 14.6997 8.75033 14.5408 8.75033 14.375V8.125ZM11.8753 7.5C12.0411 7.5 12.2001 7.56585 12.3173 7.68306C12.4345 7.80027 12.5003 7.95924 12.5003 8.125V14.375C12.5003 14.5408 12.4345 14.6997 12.3173 14.8169C12.2001 14.9342 12.0411 15 11.8753 15C11.7096 15 11.5506 14.9342 11.4334 14.8169C11.3162 14.6997 11.2503 14.5408 11.2503 14.375V8.125C11.2503 7.95924 11.3162 7.80027 11.4334 7.68306C11.5506 7.56585 11.7096 7.5 11.8753 7.5ZM5.61199 15.3892C5.65694 15.853 5.87303 16.2835 6.21813 16.5968C6.56324 16.91 7.01261 17.0834 7.47866 17.0833H12.522C12.988 17.0834 13.4374 16.91 13.7825 16.5968C14.1276 16.2835 14.3437 15.853 14.3887 15.3892L15.3537 5.41667H4.64699L5.61199 15.3892Z" />
        </svg>
      )
    case Icon.Import:
      return (
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            d="M12.084 6.75195C13.7152 6.76095 14.5987 6.8337 15.1747 7.4097C15.834 8.06895 15.834 9.12945 15.834 11.2505V12.0005C15.834 14.1222 15.834 15.1827 15.1747 15.842C14.5162 16.5005 13.455 16.5005 11.334 16.5005H5.33398C3.21298 16.5005 2.15173 16.5005 1.49323 15.842C0.833984 15.182 0.833984 14.1222 0.833984 12.0005V11.2505C0.833984 9.12945 0.833984 8.06895 1.49323 7.4097C2.06923 6.8337 2.95273 6.76095 4.58398 6.75195"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M8.33398 11.25V1.5M8.33398 1.5L10.584 4.125M8.33398 1.5L6.08398 4.125"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case Icon.Up:
      return (
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5899 7.08991C11.2895 7.39031 10.8168 7.41342 10.4899 7.15923L10.4114 7.08991L6.00065 2.67982L1.58991 7.08991C1.2895 7.39031 0.816811 7.41342 0.489902 7.15923L0.411396 7.08991C0.110992 6.7895 0.0878839 6.31681 0.342072 5.9899L0.411396 5.9114L5.4114 0.911396C5.7118 0.610992 6.18449 0.587884 6.5114 0.842072L6.58991 0.911396L11.5899 5.9114C11.9153 6.23683 11.9153 6.76447 11.5899 7.08991Z"
          />
        </svg>
      )
    case Icon.Down:
      return (
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.410093 0.910093C0.710497 0.60969 1.18319 0.586582 1.5101 0.840769L1.5886 0.910093L5.99935 5.32018L10.4101 0.910093C10.7105 0.60969 11.1832 0.586582 11.5101 0.840769L11.5886 0.910093C11.889 1.2105 11.9121 1.68319 11.6579 2.0101L11.5886 2.0886L6.5886 7.0886C6.2882 7.38901 5.81551 7.41212 5.4886 7.15793L5.41009 7.0886L0.410093 2.0886C0.0846564 1.76317 0.0846564 1.23553 0.410093 0.910093Z"
          />
        </svg>
      )
    case Icon.ArrowUp:
      return (
        <svg
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path d="M0.653464 3.3748C0.55865 3.46829 0.504856 3.59562 0.503919 3.72877C0.502981 3.86192 0.554975 3.98999 0.648464 4.0848C0.741953 4.17962 0.869278 4.23341 1.00243 4.23435C1.13558 4.23529 1.26365 4.18329 1.35846 4.0898L3.23846 2.2298L3.23846 11.1748C3.23846 11.3074 3.29114 11.4346 3.38491 11.5284C3.47868 11.6221 3.60586 11.6748 3.73846 11.6748C3.87107 11.6748 3.99825 11.6221 4.09202 11.5284C4.18579 11.4346 4.23846 11.3074 4.23846 11.1748V2.2298L6.08846 4.0898C6.13508 4.1361 6.19036 4.17275 6.25115 4.19768C6.31193 4.2226 6.37703 4.23531 6.44273 4.23508C6.50843 4.23485 6.57344 4.22168 6.63405 4.19632C6.69465 4.17097 6.74967 4.13392 6.79596 4.08731C6.84226 4.04069 6.87891 3.9854 6.90384 3.92462C6.92876 3.86383 6.94147 3.79873 6.94124 3.73304C6.94101 3.66734 6.92784 3.60233 6.90248 3.54172C6.87713 3.48112 6.84008 3.4261 6.79346 3.3798L3.73846 0.324804L0.653464 3.3748Z" />
        </svg>
      )
    case Icon.ArrowDown:
      return (
        <svg
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path d="M6.50333 8.2648C6.50391 8.16549 6.4749 8.06826 6.41999 7.9855C6.36509 7.90274 6.28679 7.8382 6.19507 7.80012C6.10335 7.76204 6.00236 7.75213 5.90499 7.77167C5.80761 7.7912 5.71826 7.83929 5.64833 7.9098L3.77833 9.7648L3.77833 0.824804C3.77833 0.692196 3.72565 0.56502 3.63188 0.471251C3.53811 0.377483 3.41094 0.324804 3.27833 0.324804C3.14572 0.324804 3.01854 0.377483 2.92477 0.471251C2.83101 0.56502 2.77833 0.692196 2.77833 0.824804L2.77833 9.7648L0.913328 7.9098C0.866709 7.86351 0.811428 7.82686 0.750643 7.80193C0.689857 7.777 0.624758 7.76429 0.55906 7.76453C0.493363 7.76476 0.428354 7.77793 0.367747 7.80328C0.307139 7.82864 0.252119 7.86569 0.205828 7.9123C0.159537 7.95892 0.122882 8.0142 0.0979548 8.07499C0.0730279 8.13578 0.0603179 8.20088 0.06055 8.26657C0.0610188 8.39925 0.114176 8.52632 0.208328 8.6198L3.27833 11.6748L6.34833 8.6198C6.39648 8.57392 6.43499 8.51888 6.4616 8.45792C6.48822 8.39697 6.5024 8.33131 6.50333 8.2648Z" />
        </svg>
      )
    case Icon.Move:
      return (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <path d="M10.5883 2.14592C10.6347 2.09935 10.6899 2.06241 10.7507 2.0372C10.8114 2.012 10.8765 1.99902 10.9423 1.99902C11.0081 1.99902 11.0732 2.012 11.1339 2.0372C11.1947 2.06241 11.2499 2.09935 11.2963 2.14592L13.2963 4.14592C13.3902 4.2398 13.4429 4.36714 13.4429 4.49992C13.4429 4.63269 13.3902 4.76003 13.2963 4.85392C13.2024 4.9478 13.0751 5.00055 12.9423 5.00055C12.8095 5.00055 12.6822 4.9478 12.5883 4.85392L11.4423 3.70692V6.49992C11.4423 6.63252 11.3896 6.7597 11.2959 6.85347C11.2021 6.94724 11.0749 6.99992 10.9423 6.99992C10.8097 6.99992 10.6825 6.94724 10.5887 6.85347C10.495 6.7597 10.4423 6.63252 10.4423 6.49992V3.70692L9.2963 4.85392C9.24981 4.90041 9.19462 4.93728 9.13388 4.96244C9.07314 4.9876 9.00804 5.00055 8.9423 5.00055C8.87656 5.00055 8.81146 4.9876 8.75072 4.96244C8.68998 4.93728 8.63479 4.90041 8.5883 4.85392C8.54181 4.80743 8.50494 4.75224 8.47978 4.6915C8.45462 4.63076 8.44167 4.56566 8.44167 4.49992C8.44167 4.43417 8.45462 4.36907 8.47978 4.30833C8.50494 4.24759 8.54181 4.1924 8.5883 4.14592L10.5883 2.14592ZM10.9423 11.9999C11.4727 11.9999 11.9814 11.7892 12.3565 11.4141C12.7316 11.0391 12.9423 10.5303 12.9423 9.99992C12.9423 9.46948 12.7316 8.96078 12.3565 8.5857C11.9814 8.21063 11.4727 7.99992 10.9423 7.99992C10.4119 7.99992 9.90316 8.21063 9.52809 8.5857C9.15301 8.96078 8.9423 9.46948 8.9423 9.99992C8.9423 10.5303 9.15301 11.0391 9.52809 11.4141C9.90316 11.7892 10.4119 11.9999 10.9423 11.9999ZM10.9423 10.9999C10.6771 10.9999 10.4227 10.8946 10.2352 10.707C10.0477 10.5195 9.9423 10.2651 9.9423 9.99992C9.9423 9.7347 10.0477 9.48035 10.2352 9.29281C10.4227 9.10527 10.6771 8.99992 10.9423 8.99992C11.2075 8.99992 11.4619 9.10527 11.6494 9.29281C11.8369 9.48035 11.9423 9.7347 11.9423 9.99992C11.9423 10.2651 11.8369 10.5195 11.6494 10.707C11.4619 10.8946 11.2075 10.9999 10.9423 10.9999ZM16.7963 12.3539L18.7963 10.3539C18.8429 10.3075 18.8798 10.2523 18.905 10.1916C18.9302 10.1308 18.9432 10.0657 18.9432 9.99992C18.9432 9.93415 18.9302 9.86903 18.905 9.80828C18.8798 9.74754 18.8429 9.69236 18.7963 9.64592L16.7963 7.64592C16.7024 7.55203 16.5751 7.49929 16.4423 7.49929C16.3095 7.49929 16.1822 7.55203 16.0883 7.64592C15.9944 7.7398 15.9417 7.86714 15.9417 7.99992C15.9417 8.13269 15.9944 8.26003 16.0883 8.35392L17.2353 9.49992H14.4423C14.3097 9.49992 14.1825 9.55259 14.0887 9.64636C13.995 9.74013 13.9423 9.86731 13.9423 9.99992C13.9423 10.1325 13.995 10.2597 14.0887 10.3535C14.1825 10.4472 14.3097 10.4999 14.4423 10.4999H17.2353L16.0883 11.6459C15.9944 11.7398 15.9417 11.8671 15.9417 11.9999C15.9417 12.1327 15.9944 12.26 16.0883 12.3539C16.1822 12.4478 16.3095 12.5005 16.4423 12.5005C16.5751 12.5005 16.7024 12.4478 16.7963 12.3539ZM11.2963 17.8539L13.2963 15.8539C13.3902 15.76 13.4429 15.6327 13.4429 15.4999C13.4429 15.3671 13.3902 15.2398 13.2963 15.1459C13.2024 15.052 13.0751 14.9993 12.9423 14.9993C12.8095 14.9993 12.6822 15.052 12.5883 15.1459L11.4423 16.2929V13.4999C11.4423 13.3673 11.3896 13.2401 11.2959 13.1464C11.2021 13.0526 11.0749 12.9999 10.9423 12.9999C10.8097 12.9999 10.6825 13.0526 10.5887 13.1464C10.495 13.2401 10.4423 13.3673 10.4423 13.4999V16.2929L9.2963 15.1459C9.20241 15.052 9.07508 14.9993 8.9423 14.9993C8.80952 14.9993 8.68219 15.052 8.5883 15.1459C8.49441 15.2398 8.44167 15.3671 8.44167 15.4999C8.44167 15.6327 8.49441 15.76 8.5883 15.8539L10.5883 17.8539C10.6347 17.9005 10.6899 17.9374 10.7507 17.9626C10.8114 17.9878 10.8765 18.0008 10.9423 18.0008C11.0081 18.0008 11.0732 17.9878 11.1339 17.9626C11.1947 17.9374 11.2499 17.9005 11.2963 17.8539ZM3.0883 10.3539C3.04174 10.3075 3.00479 10.2523 2.97959 10.1916C2.95438 10.1308 2.94141 10.0657 2.94141 9.99992C2.94141 9.93415 2.95438 9.86903 2.97959 9.80828C3.00479 9.74754 3.04174 9.69236 3.0883 9.64592L5.0883 7.64592C5.13479 7.59943 5.18998 7.56255 5.25072 7.53739C5.31146 7.51223 5.37656 7.49929 5.4423 7.49929C5.50804 7.49929 5.57314 7.51223 5.63388 7.53739C5.69462 7.56255 5.74981 7.59943 5.7963 7.64592C5.84279 7.6924 5.87966 7.74759 5.90482 7.80833C5.92998 7.86907 5.94293 7.93417 5.94293 7.99992C5.94293 8.06566 5.92998 8.13076 5.90482 8.1915C5.87966 8.25224 5.84279 8.30743 5.7963 8.35392L4.6493 9.49992H7.4423C7.57491 9.49992 7.70209 9.55259 7.79585 9.64636C7.88962 9.74013 7.9423 9.86731 7.9423 9.99992C7.9423 10.1325 7.88962 10.2597 7.79585 10.3535C7.70209 10.4472 7.57491 10.4999 7.4423 10.4999H4.6493L5.7963 11.6459C5.89019 11.7398 5.94293 11.8671 5.94293 11.9999C5.94293 12.1327 5.89019 12.26 5.7963 12.3539C5.70241 12.4478 5.57508 12.5005 5.4423 12.5005C5.30952 12.5005 5.18219 12.4478 5.0883 12.3539L3.0883 10.3539Z" />
        </svg>
      )
    case Icon.Intake:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4168_32311)">
            <path
              d="M14.5 16H1.5C0.67 16 0 15.33 0 14.5V2.5C0 1.67 0.67 1 1.5 1H14.5C15.33 1 16 1.67 16 2.5V14.5C16 15.33 15.33 16 14.5 16ZM1.5 2C1.22 2 1 2.22 1 2.5V14.5C1 14.78 1.22 15 1.5 15H14.5C14.78 15 15 14.78 15 14.5V2.5C15 2.22 14.78 2 14.5 2H1.5Z"
              fill={color || primaryColor}
            />
            <path
              d="M4.5 4C4.22 4 4 3.78 4 3.5V0.5C4 0.22 4.22 0 4.5 0C4.78 0 5 0.22 5 0.5V3.5C5 3.78 4.78 4 4.5 4ZM11.5 4C11.22 4 11 3.78 11 3.5V0.5C11 0.22 11.22 0 11.5 0C11.78 0 12 0.22 12 0.5V3.5C12 3.78 11.78 4 11.5 4ZM15.5 6H0.5C0.22 6 0 5.78 0 5.5C0 5.22 0.22 5 0.5 5H15.5C15.78 5 16 5.22 16 5.5C16 5.78 15.78 6 15.5 6Z"
              fill={color || primaryColor}
            />
          </g>
          <defs>
            <clipPath id="clip0_4168_32311">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case Icon.Lock:
      return (
        <svg
          width="13"
          height="20"
          viewBox="0 0 13 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 1.25C7.41304 1.25 8.04893 1.51339 8.51777 1.98223C8.98661 2.45107 9.25 3.08696 9.25 3.75V8.75H4.25V3.75C4.25 3.08696 4.51339 2.45107 4.98223 1.98223C5.45107 1.51339 6.08696 1.25 6.75 1.25ZM10.5 8.75V3.75C10.5 2.75544 10.1049 1.80161 9.40165 1.09835C8.69839 0.395088 7.74456 0 6.75 0C5.75544 0 4.80161 0.395088 4.09835 1.09835C3.39509 1.80161 3 2.75544 3 3.75V8.75C2.33696 8.75 1.70107 9.01339 1.23223 9.48223C0.763392 9.95107 0.5 10.587 0.5 11.25V17.5C0.5 18.163 0.763392 18.7989 1.23223 19.2678C1.70107 19.7366 2.33696 20 3 20H10.5C11.163 20 11.7989 19.7366 12.2678 19.2678C12.7366 18.7989 13 18.163 13 17.5V11.25C13 10.587 12.7366 9.95107 12.2678 9.48223C11.7989 9.01339 11.163 8.75 10.5 8.75ZM3 10H10.5C10.8315 10 11.1495 10.1317 11.3839 10.3661C11.6183 10.6005 11.75 10.9185 11.75 11.25V17.5C11.75 17.8315 11.6183 18.1495 11.3839 18.3839C11.1495 18.6183 10.8315 18.75 10.5 18.75H3C2.66848 18.75 2.35054 18.6183 2.11612 18.3839C1.8817 18.1495 1.75 17.8315 1.75 17.5V11.25C1.75 10.9185 1.8817 10.6005 2.11612 10.3661C2.35054 10.1317 2.66848 10 3 10Z"
            fill={color || primaryColor}
          />
        </svg>
      )
    case Icon.LockLarge:
      return (
        <svg
          width="18"
          height="28"
          viewBox="0 0 18 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.9375 2.1875C9.83261 2.1875 10.6911 2.54308 11.324 3.17601C11.9569 3.80895 12.3125 4.66739 12.3125 5.5625V12.3125H5.5625V5.5625C5.5625 4.66739 5.91808 3.80895 6.55101 3.17601C7.18395 2.54308 8.04239 2.1875 8.9375 2.1875ZM14 12.3125V5.5625C14 4.21984 13.4666 2.93217 12.5172 1.98277C11.5678 1.03337 10.2802 0.5 8.9375 0.5C7.59484 0.5 6.30718 1.03337 5.35777 1.98277C4.40837 2.93217 3.875 4.21984 3.875 5.5625V12.3125C2.97989 12.3125 2.12145 12.6681 1.48851 13.301C0.855579 13.934 0.5 14.7924 0.5 15.6875V24.125C0.5 25.0201 0.855579 25.8786 1.48851 26.5115C2.12145 27.1444 2.97989 27.5 3.875 27.5H14C14.8951 27.5 15.7536 27.1444 16.3865 26.5115C17.0194 25.8786 17.375 25.0201 17.375 24.125V15.6875C17.375 14.7924 17.0194 13.934 16.3865 13.301C15.7536 12.6681 14.8951 12.3125 14 12.3125ZM3.875 14H14C14.4476 14 14.8768 14.1778 15.1932 14.4943C15.5097 14.8107 15.6875 15.2399 15.6875 15.6875V24.125C15.6875 24.5726 15.5097 25.0018 15.1932 25.3182C14.8768 25.6347 14.4476 25.8125 14 25.8125H3.875C3.42745 25.8125 2.99823 25.6347 2.68176 25.3182C2.36529 25.0018 2.1875 24.5726 2.1875 24.125V15.6875C2.1875 15.2399 2.36529 14.8107 2.68176 14.4943C2.99823 14.1778 3.42745 14 3.875 14Z"
            fill={color || primaryColor}
          />
        </svg>
      )
    case Icon.Unlock:
      return (
        <svg
          width={width || '17'}
          height={height || '20'}
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0747 1.25C12.4117 1.25 11.7758 1.51339 11.3069 1.98223C10.8381 2.45107 10.5747 3.08696 10.5747 3.75V8.75C11.2377 8.75 11.8736 9.01339 12.3425 9.48223C12.8113 9.95107 13.0747 10.587 13.0747 11.25V17.5C13.0747 18.163 12.8113 18.7989 12.3425 19.2678C11.8736 19.7366 11.2377 20 10.5747 20H3.07471C2.41167 20 1.77578 19.7366 1.30694 19.2678C0.838099 18.7989 0.574707 18.163 0.574707 17.5V11.25C0.574707 10.587 0.838099 9.95107 1.30694 9.48223C1.77578 9.01339 2.41167 8.75 3.07471 8.75H9.32471V3.75C9.32471 2.75544 9.71979 1.80161 10.4231 1.09835C11.1263 0.395088 12.0801 0 13.0747 0C14.0693 0 15.0231 0.395088 15.7264 1.09835C16.4296 1.80161 16.8247 2.75544 16.8247 3.75V8.75C16.8247 8.91576 16.7589 9.07473 16.6416 9.19194C16.5244 9.30915 16.3655 9.375 16.1997 9.375C16.0339 9.375 15.875 9.30915 15.7578 9.19194C15.6406 9.07473 15.5747 8.91576 15.5747 8.75V3.75C15.5747 3.08696 15.3113 2.45107 14.8425 1.98223C14.3736 1.51339 13.7377 1.25 13.0747 1.25ZM3.07471 10C2.74319 10 2.42524 10.1317 2.19082 10.3661C1.9564 10.6005 1.82471 10.9185 1.82471 11.25V17.5C1.82471 17.8315 1.9564 18.1495 2.19082 18.3839C2.42524 18.6183 2.74319 18.75 3.07471 18.75H10.5747C10.9062 18.75 11.2242 18.6183 11.4586 18.3839C11.693 18.1495 11.8247 17.8315 11.8247 17.5V11.25C11.8247 10.9185 11.693 10.6005 11.4586 10.3661C11.2242 10.1317 10.9062 10 10.5747 10H3.07471Z"
            fill={color || primaryColor}
          />
        </svg>
      )
    case Icon.Link:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || '24'}
          height={height || '24'}
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M13.2571 4.45714L15.7714 1.94286C17.0286 0.685714 19.5429 0.685714 20.8 1.94286L22.0571 3.2C23.3143 4.45714 23.3143 6.97143 22.0571 8.22857L15.7714 14.5143C14.5143 15.7714 12 15.7714 10.7429 14.5143M10.7429 19.5429L8.22857 22.0571C6.97143 23.3143 4.45714 23.3143 3.2 22.0571L1.94286 20.8C0.685714 19.5429 0.685714 17.0286 1.94286 15.7714L8.22857 9.48571C9.48571 8.22857 12 8.22857 13.2571 9.48571"
            stroke={color || '#8A68C8'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case Icon.ExternalLink:
      return (
        <svg
          width={width || '20'}
          height={height || '20'}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5 8.5L19 1M19 6V1H14M19 12V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H8"
            stroke={color || 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case Icon.Info:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || '21'}
          height={height || '21'}
          viewBox="0 0 24 24"
          fill="white"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke={color || '#007882'}
            strokeWidth="2"
          />
          <line
            x1="12"
            y1="8"
            x2="12"
            y2="12"
            stroke={color || '#007882'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="12"
            y1="16"
            x2="12.01"
            y2="16"
            stroke={color || '#007882'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )
    default:
      return null
  }
}

export default Svg
